module.exports = __webpack_public_path__ + "img/6D.4e64aa47.png";